#import "../fragments/landing-page-stub-fragment.graphql"

query GetLandingPages($archived: Boolean) {
    pages(archived: $archived) {
        ...LandingPageStubFragment
    }
}
